import { find } from 'lodash'

export default {
  isValid () {
    return find(this.schedules, {'lock': true})
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/computed.js